import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'stx-checkout-exit-confirmation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatButton,
    MatDialogClose,
    MatDialogActions,
  ],
  template: `
    <h2 mat-dialog-title>¿Estás seguro de que quieres salir?</h2>

    <mat-dialog-content>
      <p>
        Si sales de esta página, perderás tus asientos reservados y tendrás que
        volver a seleccionarlos.
      </p>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button
        mat-button
        cdkFocusInitial
        [mat-dialog-close]="false"
      >
        Cancelar
      </button>
      <button
        mat-button
        [mat-dialog-close]="true"
      >
        Salir de todas formas
      </button>
    </mat-dialog-actions>
  `,
})
export class CheckoutExitConfirmationComponent {}
